import { DEFAULTS_VIEWER } from "./defaults";
import { HTML_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginHtml = (config) => {
  return {
    config: { ...DEFAULTS_VIEWER, ...config },
    type: HTML_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginHtml
};
//# sourceMappingURL=viewer-loadable.js.map
